/*
 *  Модуль сайдбара. Содерижт 3 региона (header, menu , footer). Footer пока не включен
 *  @return Marionette.LayoutView объект
 *  @author Tretyakov Pavel <tretjakov.pavel@gmail.com>
 */
define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var tplSidebar = require('text!tmpls/sidebar.tpl').default;

    //var SidebarHeader = require('views/sidebar/header');
    var SidebarMenu   = require('components/menu/collectionView');
    var AppConfig     = require("config/application");
    require('lptSetter');

    return Marionette.LayoutView.extend({
        template  : tplSidebar,
        id        : 'main-menu-wrapper',
        className : 'page-sidebar-wrapper',
        supportUrl: 'http://faq.lptracker.io/',

        ui: {
            btnSupport: '.btnSupport',
            btnIntro  : '.btnIntro',
            overlay   : '.js-sidebar-overlay',
            logo      : '.js-logo',
            user      : '.js-user',
            closeUser : '.js-close'
        },

        events: {
            'click @ui.btnIntro': 'introStart',
            'scroll'            : 'onSelectListScroll',
            'click @ui.logo'    : 'toggleUser',
            'click @ui.closeUser': 'closeUser',
        },

        allow_callback: true,

        introStart: function() {
            app.introStart();
        },

        regions: {
            regionHeader: '#sidebar-header',
            regionMenu  : '#sidebar-menu'
        },

        initialize: function () {
            var that = this;
            that.listenTo(app.Vents, 'app:beforeChangeProject', that.showLoader);
            that.listenTo(app,'menu:refreshed', that.hideLoader);

            that.listenTo(app.Vents, 'app:changeProject', function(){
                app.global_refresh_menu = true;
            });
            that.listenTo(app.Vents, 'page:start:save', that.showOverlay);
            that.listenTo(app.Vents, 'page:end:save', that.hideOverlay);
            that.listenTo(app.Router, 'route', that.closeUser);
        },

        showOverlay: function() {
            this.ui.overlay.show();
        },

        hideOverlay: function() {
            this.ui.overlay.hide();
        },

        serializeData: function() {
            const product = app.Models.User.get('product');

            return {
                supportUrl: this.supportUrl,
                showIntro: false, //(app.Models.User.get('profile_type') == 0 && app.Models.Account.get('tariff_id'))
                userName: app.Models.User.get('name'),
                userAvatar: app.Models.User.get('avatar'),
                accountId: app.AUTH_ID,
                userId: app.Models.User.get('profile_type') == 0 ? 'main' : app.Models.User.get('id'),
                showUser: app.Models.Account.get('telephony_version') == 2,
                showAvatar: app.Models.Account.get('telephony_version') == 2 && (!product || product.options.avatar),
            }
        },

        onRender: function () {
            var that = this;
            $('#main-menu').removeClass('loading');
            this.regionHeader.empty();
            //this.regionHeader.show(new SidebarHeader());
            this.regionMenu.empty();
            this.regionMenu.show(new SidebarMenu());
        },

        onShow: function() {
            this.$('.scrollbar-macosx').scrollbar();
            this.$el.lptSetter();
        },

        onSelectListScroll: function (e) {
            e.stopPropagation();
        },

        showLoader: function() {
            this.$('.b-content__loader').show();
        },

        hideLoader: function() {
            this.$('.b-content__loader').hide();
        },

        closeUser: function() {
            this.toggleUser(false);
        },

        toggleUser: function(state) {
            this.ui.user.toggleClass('sidebar-header__user--opened', state);
        }
    });
});
